<template>
    <div>
        <el-button type="primary" @click="add">新增医疗设备</el-button>
        <customTable class="mt20" :tableData="tableData" :showPages="false" :column="column"
            :header-cell-style="{ background: '#F0F1F3' }">
            <template slot="action" slot-scope="{ row } ">
                <el-button type="text" @click="remove(row)">删除</el-button>
            </template>
        </customTable>
        <custom-dialog width="500px" title="新增医疗设备" v-if="dialogShow" :visible="dialogShow" @close="close" @save="comfirm">
            <el-form slot="content" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
                class="demo-ruleForm">
                <el-form-item label="医疗设备名称" prop="deviceName">
                    <el-input v-model="ruleForm.deviceName"></el-input>
                </el-form-item>
                <el-form-item label="所属科室" prop="belongClinic">
                    <el-select v-model="ruleForm.belongClinic" placeholder="请选择活动区域">
                        <el-option label="中医科" value="中医科"></el-option>
                        <el-option label="针灸科" value="针灸科"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类别" prop="deviceCategory">
                    <el-select v-model="ruleForm.deviceCategory" placeholder="请选择活动区域">
                        <el-option label="1｜治疗设备" value="1｜治疗设备"></el-option>
                        <el-option label="2｜诊断设备" value="2｜诊断设备"></el-option>
                        <el-option label="3｜辅助设备" value="3｜辅助设备"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备型号" prop="deviceType">
                    <el-input v-model="ruleForm.deviceType"></el-input>
                </el-form-item>
                <el-form-item label="品牌" prop="brand">
                    <el-input v-model="ruleForm.brand"></el-input>
                </el-form-item>
                <el-form-item label="产地" prop="place">
                    <el-input v-model="ruleForm.place"></el-input>
                </el-form-item>
                <el-form-item label="是否大型设备" prop="largeDeviceFlag">
                    <el-radio-group v-model="ruleForm.largeDeviceFlag">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="购买日期" prop="buyTime">
                    <el-date-picker v-model="ruleForm.buyTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="开始使用日期" prop="startUseTime">
                    <el-date-picker v-model="ruleForm.startUseTime" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="使用年限" prop="life">
                    <el-input v-model="ruleForm.life"></el-input>
                </el-form-item>
            </el-form>
        </custom-dialog>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import CustomDialog from '@/components/customDialog/CustomDialog'
import { save, list, remove } from '@/api/equipment'
export default {
    // 定义引入的组件
    components: { customTable, CustomDialog },
    props: {},
    data() {
        return {
            dialogShow: false,
            tableData: [],
            column: [
                { label: '设备名称', prop: 'deviceName' },
                { label: '设备类别', prop: 'deviceCategory' },
                { label: '品牌', prop: 'brand' },
                { label: '购买日期', prop: 'buyTime' },
                { label: '使用年限', prop: 'life' },
                { label: '操作', slotName: 'action' }
            ],
            ruleForm: {
                deviceName: '',
                belongClinic: '',
                deviceCategory: '',
                deviceType: '',
                brand: '',
                place: '',
                largeDeviceFlag: '',
                buyTime: '',
                startUseTime: '',
                life: ''
            },
            rules: {
                deviceName: [
                    { required: true, message: '请输入设备名称', trigger: 'blur' },
                ],
            }
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() {
        this.getList()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        add() {
            this.ruleForm = {
                deviceName: '',
                belongClinic: '',
                deviceCategory: '',
                deviceType: '',
                brand: '',
                place: '',
                largeDeviceFlag: '',
                buyTime: '',
                startUseTime: '',
                life: ''
            },
                this.dialogShow = true
        },
        close() {
            this.$refs.ruleForm.resetFields();
            this.dialogShow = false
        },
        comfirm() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    let { code, data } = await save(this.ruleForm)
                    if (code == 200) {
                        this.$message.success('保存成功')
                        this.dialogShow = false
                        this.getList()
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async getList() {
            let { code, rows } = await list({ currentPage: 1, pageSize: 50 })
            if (code == 200) {
                this.tableData = rows
            }
        },
        async remove(row) {
            let { code, data } = await remove({ treatDeviceId: row.treatDeviceId })
            if (code == 200) {
                this.$message.success('删除成功')
                this.getList()
            }
        }
    },
}
</script>
<style lang="less" scoped></style>